import { API, setAuthToken } from '../../../config/API.js';
import { GET_SHE, SET_LOADING_SHE, SET_PAGINATION_SHE } from '../constant.js';

export const getDataSHE = (params) => {
  return (dispatch) => {
    const token = localStorage.getItem("jwt_token");
    setAuthToken(token);
    dispatch({
      type: SET_LOADING_SHE,
      payload: true,
    });
    API.get(`admin/news/she?${new URLSearchParams(params).toString()}`)
      .then((res) => {
        dispatch({
          type: GET_SHE,
          payload: res.data.data || [],
        });
        dispatch({
          type: SET_PAGINATION_SHE,
          payload: res?.data?.data?.last_page,
        });
      })
      .catch(() => {
        dispatch({
          type: GET_SHE,
          payload: [],
        });
        dispatch({
          type: SET_PAGINATION_SHE,
          payload: 0,
        });
      });
  };
};

export const addDataSHE = (params) => {
  const token = localStorage.getItem("jwt_token");
  setAuthToken(token);
  return API.post("admin/news/she/add", params);
};

export const getDetailDataSHE = (code) => {
  const token = localStorage.getItem("jwt_token");
  setAuthToken(token);
  return API.get(`admin/news/she/${code}`);
};

export const updDataSHE = (params) => {
  const token = localStorage.getItem("jwt_token");
  setAuthToken(token);
  return API.post("admin/news/she/edit", params);
};

export const delDataSHE = (code) => {
  const token = localStorage.getItem("jwt_token");
  setAuthToken(token);
  return API.delete("admin/news/she/delete/" + code);
};
